import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";
import { Logo } from "../components/Logo";
import api from "../lib/api";

export default function PaiementSucces() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
      } catch (e) { /* retry */ }
      attempts += 1;
      if (attempts < 10) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="min-h-screen bg-paper flex flex-col items-center justify-center px-6 text-center">
      <Link to="/" aria-label="Accueil VAV"><Logo /></Link>
      {state === "loading" && <p className="mt-10 font-serif italic text-2xl text-smoke">Confirmation de votre paiement…</p>}
      {state === "paid" && (
        <>
          <span className="mt-10 inline-flex items-center justify-center w-16 h-16 rounded-full bg-sage/15">
            <Check size={28} strokeWidth={1.5} className="text-sagedark" />
          </span>
          <h1 className="mt-8 font-serif text-4xl md:text-5xl tracking-tight text-ink">Votre module est activé.</h1>
          <p className="mt-4 max-w-md text-smoke text-sm md:text-base leading-relaxed">
            Votre abonnement est confirmé. Votre accompagnement VAV commence maintenant —
            tests, coaching à la demande et dossier de vie professionnelle vous attendent.
          </p>
          <Link data-testid="payment-success-espace-cta" to="/espace-client" className="mt-10 inline-flex rounded-full bg-ink text-paper px-8 py-4 text-sm hover:bg-sagedark transition-colors duration-300">
            Accéder à mon espace
          </Link>
        </>
      )}
      {state === "pending" && (
        <>
          <h1 className="mt-10 font-serif text-4xl tracking-tight text-ink">Paiement en cours de confirmation</h1>
          <p className="mt-4 max-w-md text-smoke text-sm">Stripe confirme encore votre paiement. Vérifiez votre espace dans quelques instants.</p>
          <Link data-testid="payment-pending-espace-cta" to="/espace-client" className="mt-10 inline-flex rounded-full bg-ink text-paper px-8 py-4 text-sm hover:bg-sagedark transition-colors duration-300">Mon espace</Link>
        </>
      )}
      {state === "error" && <p className="mt-10 text-smoke">Session introuvable.</p>}
    </div>
  );
}
